import { defineCommerceEngine } from "@coveo/headless-react/ssr-commerce";
import engineConfig from "./commerce-engine-config";

interface EngineDefinition {
  useEngine: any;
  controllers: any;
  listingEngineDefinition: any;
  searchEngineDefinition: any;
  recommendationEngineDefinition: any;
  standaloneEngineDefinition: any;
}

export const engineDefinition: EngineDefinition =
  defineCommerceEngine(engineConfig);

export const {
  listingEngineDefinition,
  searchEngineDefinition,
  recommendationEngineDefinition,
  standaloneEngineDefinition,
  useEngine,
} = engineDefinition;

export const {
  useStandaloneSearchBox,
  useInstantProducts,
  useParameterManager,
  useProductList,
  useContext,
  useSort,
  useFacetGenerator,
  usePagination,
  useSummary,
} = engineDefinition.controllers;
